import { MdKeyboardArrowRight } from 'react-icons/md';
import React from 'react';
import { IS_FRAME_SERVICE } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/frameService';
import { dispatchTrackingEvent, SPECIAL_OFFER } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/tracking';
import DragScrollWrapper from '@PROJECT_ROOT/assets/responsive-frontend/parts/DragScrollWrapper/DragScrollWrapper';

export default class SpecialOffer extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    render() {
        const { data } = this.props;

        return (
            data && (
                <div className="specialOffer">
                    <a href={data.hyperlink.redirectURL} title={data.hyperlink.seoTitle} className="specialOffer--header">
                        <h2>{data.title}</h2>
                        <span className="line" />
                        <span className="specialOffer--seeMore">
                            <span>{data.hyperlink.redirectURLTitle}</span>
                            <MdKeyboardArrowRight />
                        </span>
                    </a>
                    <DragScrollWrapper
                        ref={this.ref}
                        className="specialOfferOuter"
                        horizontal={true}
                        vertical={false}
                    >
                        {data.items.map((item, index) => (
                            <div className="specialOfferItem" key={index}>
                                <a
                                    href={item.hyperlink.redirectURL}
                                    title={item.hyperlink.seoTitle}
                                    onClick={() => {
                                        if (!IS_FRAME_SERVICE) dispatchTrackingEvent(SPECIAL_OFFER, { offerTitle: item.title });
                                    }}
                                >
                                    <div className="card">
                                        <div className="card-body">
                                            <span>{item.apartmentsNumber}</span>
                                            <div>
                                                <img loading="lazy" src={item.image.sourceURL} className="card-img-top" alt={item.image.altText} title={item.image.titleText} />
                                                <h3 className="card-title">{item.hyperlink.redirectURLTitle}</h3>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </DragScrollWrapper>
                </div>
            )
        );
    }
}
